import {isRejectedWithValue} from '@reduxjs/toolkit'
import {setSearchBoxValues} from 'modules/searchBox/slice'

import {
  logTimeEnd,
  logTimeStart
} from '@vio/core/src/_web/utils/logging/performanceTimer'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import {searchApi} from '@vio/core/src/sapi/services/searchApi'
import {offersSearchStarted} from '@vio/core/src/sapi/services/searchApi/action'

import {MiddlewareType} from '../middlewareList'

const middleware: MiddlewareType = store => next => async action => {
  const {dispatch} = store

  // Sync default dates from SAPI back to search box
  if (offersSearchStarted.match(action)) {
    const {checkIn, checkOut, rooms} = action.payload
    dispatch(
      setSearchBoxValues({
        checkIn,
        checkOut,
        rooms
      })
    )
  }

  if (searchApi.endpoints.getUserReviews.matchPending(action)) {
    logTimeStart(Entity.ReviewsFetch)
    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.ReviewsFetch,
        action: Action.Requested,
        payload: {
          hotelId: action.meta.arg.originalArgs.hotelId
        }
      })
    )
    return next(action)
  }

  if (searchApi.endpoints.getUserReviews.matchFulfilled(action)) {
    const requestHotelId = action.meta.arg.originalArgs.hotelId
    const timingResult = logTimeEnd(Entity.ReviewsFetch)

    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.ReviewsFetch,
        action: Action.Succeeded,
        payload: {
          hotelId: requestHotelId,
          reviewsCount: action.payload.reviews.length,
          timing: timingResult
        }
      })
    )
    return next(action)
  }

  if (
    searchApi.endpoints.getUserReviews.matchRejected(action) &&
    isRejectedWithValue(action)
  ) {
    const timingResult = logTimeEnd(Entity.ReviewsFetch)
    dispatch(
      trackEvent({
        category: Category.System,
        entity: Entity.ReviewsFetch,
        action: Action.Errored,
        payload: {
          error: action.payload,
          timing: timingResult
        }
      })
    )
    return next(action)
  }

  return next(action)
}
export default middleware
